// "Sort into groups" questions (2026-10-13): 2 or 3 named groups and a few
// items, and every item goes into exactly one group. An answer is sent, and
// its answer key is stored, as one string per item, "<item id>=<group id>"
// (for example "a=l", "b=c"), and the two are marked by comparing those
// strings.
//
// An entry looks like a several-boxes entry ("a=12", see boxAnswer.ts) with a
// group's letter where the number would be. Never tell the two apart by the
// shape of the string: a sort question is one whose content has `groups` and
// `items`, a several-boxes question is one whose content has `boxes`.

// Item ids and group ids are single lower-case letters. They are separate
// lists, so a group may have the same letter as an item.
const SORT_ID = /^[a-z]$/;

export function isSortId(id: unknown): id is string {
  return typeof id === 'string' && SORT_ID.test(id);
}

// One item's entry, "a=l". Null when either id is not a single letter.
export function sortEntry(itemId: string, groupId: string): string | null {
  return isSortId(itemId) && isSortId(groupId) ? `${itemId}=${groupId}` : null;
}

// The other way: "a=l" back into its item id and group id. Null for anything
// else (a several-boxes entry, a tick-all or put-in-order id, for example).
export function parseSortEntry(
  entry: unknown,
): { itemId: string; groupId: string } | null {
  if (typeof entry !== 'string') return null;
  const match = /^([a-z])=([a-z])$/.exec(entry);
  if (!match) return null;
  const [, itemId = '', groupId = ''] = match;
  return { itemId, groupId };
}
